const Handlebars = require('handlebars');

$(document).ready(function() {
    // virtual tours
    if ($('#orderModalTemplate').length) {
        const source = document.querySelector('#orderModalTemplate').innerHTML;

        orderTemplate = Handlebars.compile(source);

        $('.orderModalTrigger').on('click', processOrderModalContent);
    }
});

function processOrderModalContent()
{

    context = JSON.parse(this.dataset.modalcontent);

    const html = orderTemplate(context);

    // get the element to set the new HTML into
    const destination = document.querySelector(".orderModal");

    // set the new HTML
    destination.innerHTML = html;
}